import React from 'react';
import ImpactBadge from '../ui/badges/ImpactBadge';
import './RecommendationDialog.css';

interface RecommendationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  recommendation?: {
    title?: string;
    description?: string;
    impact?: string;
    priority?: string;
    timeline?: string;
    [key: string]: any;
  };
}

const RecommendationDialog: React.FC<RecommendationDialogProps> = ({
  isOpen,
  onClose,
  recommendation
}) => {
  if (!isOpen || !recommendation) return null;


  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="recommendation-dialog-backdrop" onClick={handleBackdropClick}>
      <div className="recommendation-dialog">
        <div className="recommendation-dialog-header">
          <div className="recommendation-dialog-title">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_6_1514)">
                <path d="M13.3334 12.1141V5.66611C13.3334 5.61344 13.2667 0.357444 7.6427 -0.000556053C7.34365 -0.0248065 7.04524 0.0533917 6.79651 0.221189C6.54778 0.388986 6.36353 0.636401 6.27403 0.922777C6.13882 1.5149 5.85296 2.06207 5.44417 2.51128C5.03538 2.96049 4.5175 3.2965 3.9407 3.48678C3.56647 3.63432 3.24507 3.89066 3.01797 4.22268C2.79088 4.55471 2.66852 4.94719 2.6667 5.34944C2.66705 5.69854 2.80589 6.03323 3.05273 6.28008C3.29958 6.52692 3.63427 6.66576 3.98337 6.66611H6.8147C6.64267 7.17425 6.36466 7.64004 5.99906 8.03264C5.63347 8.42524 5.18864 8.7357 4.69403 8.94345C4.09812 9.20407 3.58995 9.63094 3.2304 10.1729C2.87084 10.7149 2.67513 11.3491 2.6667 11.9994V12.1128C2.22115 12.2695 1.84544 12.5789 1.60612 12.9861C1.36681 13.3933 1.27933 13.872 1.35918 14.3376C1.43902 14.8031 1.68105 15.2253 2.04239 15.5295C2.40372 15.8337 2.86105 16.0002 3.33337 15.9994H12.6667C13.1384 15.9993 13.5948 15.8324 13.9553 15.5283C14.3158 15.2242 14.5573 14.8025 14.6371 14.3377C14.7169 13.8728 14.6298 13.3947 14.3912 12.9879C14.1526 12.581 13.778 12.2715 13.3334 12.1141ZM5.2407 10.1594C6.05991 9.80687 6.77419 9.24872 7.31437 8.53907C7.85455 7.82941 8.20233 6.99229 8.32403 6.10878C8.3399 6.01331 8.3348 5.91554 8.30908 5.82225C8.28336 5.72896 8.23764 5.64238 8.17509 5.56854C8.11254 5.4947 8.03466 5.43536 7.94687 5.39465C7.85908 5.35393 7.76347 5.33282 7.6667 5.33278L4.00003 5.34944C4.00257 5.21276 4.04604 5.07998 4.12484 4.96826C4.20363 4.85655 4.31413 4.77104 4.44203 4.72278C5.20016 4.45731 5.88119 4.00913 6.4249 3.41786C6.96861 2.82659 7.35825 2.11045 7.55937 1.33278C8.72152 1.32313 9.84039 1.77318 10.6722 2.58486C11.504 3.39654 11.9813 4.50407 12 5.66611V11.9994H4.00003C4.00516 11.6052 4.12531 11.2211 4.34571 10.8942C4.56611 10.5674 4.87717 10.312 5.2407 10.1594ZM12.6667 14.6661H3.33337C3.15656 14.6661 2.98699 14.5959 2.86196 14.4709C2.73694 14.3458 2.6667 14.1763 2.6667 13.9994C2.6667 13.8226 2.73694 13.6531 2.86196 13.528C2.98699 13.403 3.15656 13.3328 3.33337 13.3328H12.6667C12.8435 13.3328 13.0131 13.403 13.1381 13.528C13.2631 13.6531 13.3334 13.8226 13.3334 13.9994C13.3334 14.1763 13.2631 14.3458 13.1381 14.4709C13.0131 14.5959 12.8435 14.6661 12.6667 14.6661Z" fill="#A6A6A6" />
              </g>
              <defs>
                <clipPath id="clip0_6_1514">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div>Strategic Recommendation Details</div>
          </div>
          <button className="dialog-close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
                  <h3 className="recommendation-title-label">
            {recommendation.title || 'Recommendation'}
          </h3>

        <div className="recommendation-dialog-body">


          {recommendation.description && (
            <p className="recommendation-dialog-description">
              {recommendation.description}
            </p>
          )}

          {recommendation.impact && (
            <div className="recommendation-dialog-impact">
          <div className="recommendation-meta">
            <ImpactBadge impact={recommendation.priority || 'MEDIUM'} />
            <span className="dialog-timeline">{recommendation.timeline || '6-12 MONTHS'}</span>
          </div>
              <p className="impact-section-text">{recommendation.impact}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecommendationDialog;